<template>
  <component
    :is="component.name"
    v-bind="component.props"
    v-model="internalValue"
    :disabled="disabled"
  >{{ component.text }}</component>
</template>

<script>
import DatetimePicker from './DatetimePicker'
import NumberField from './NumberField'
import SelectCascade from './SelectCascade'

export default {
  name: 'form-schema-field',

  components: {
    'datetime-picker': DatetimePicker,
    'number-field': NumberField,
    'select-cascade': SelectCascade
  },

  props: ['value', 'schema', 'required', 'disabled'],

  data: function () {
    return {
      internalValue: this.value,
      component: this.getComponent()
    }
  },

  mounted () {
    this.sync()
  },

  watch: {
    value (newValue, oldValue) {
      this.internalValue = newValue
    },
    internalValue (newValue, oldValue) {
      this.sync()
    }
  },

  methods: {

    sync () {
      this.$emit('input', this.internalValue)
    },

    getRules (sch) {
      let rules = []
      if (this.required) {
        rules.push(v => v !== undefined && v !== null && v !== '' || `${sch.title} is required`)
      }
      if (sch.type == 'string') {
        if (sch.pattern) {
          rules.push(v => v != null && v.match(sch.pattern) != null || `${sch.title} does not match: ${sch.pattern}`)
        }
        if (sch.minLength != null) {
          rules.push(v => v != null && v.length >= sch.minLength || `${sch.title} must have ${sch.minLength} characters minimum`)
        }
        if (sch.maxLength != null) {
          rules.push(v => v != null && v.length <= sch.maxLength || `${sch.title} must not exceed ${sch.maxLength} characters`)
        }
        if (sch.format == 'email') {
          let emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
          rules.push(v => v != null && (v == '' || v.match(emailRegex) != null) || 'Email not valid.')
        }
      } else if (sch.type == 'number') {
        rules.push(v => v == null || v == '' || (v != null && v.match(/^-?[0-9]+[,\.]?[0-9]*$/) != null) || 'Invalid number')
        if (sch.minimum != null) {
          rules.push(v => !isNaN(parseFloat(v)) && parseFloat(v) >= sch.minimum || `${sch.title} cannot be less than ${sch.minimum}`)
        }
        if (sch.maximum != null) {
          rules.push(v => !isNaN(parseFloat(v)) && parseFloat(v) <= sch.maximum || `${sch.title} cannot be greater than ${sch.maximum}`)
        }
      }
      return rules
    },

    getComponent () {
      let sch = this.schema
      let label = this.required ? `${sch.title} *` : sch.title
      if (sch.enum != null) {
        // bind to select
        if (sch.type == 'string') {
          let componentName = sch.pattern != null ? 'v-combobox' : 'v-select'
          let multiple = sch.properties != null && sch.properties.multiple == true
          return {
            name: componentName,
            props: {
              clearable: !this.required,
              label,
              returnObject: false,
              multiple: multiple,
              items: sch.enum,
              itemText: 'label',
              itemValue: 'key',
              rules: this.getRules(sch)
            }
          }
        } else {
          // bind to a recursive select "select-cascade" if the field type is not a string
          return {
            name: 'select-cascade',
            props: {
              label,
              items: sch.enum
            }
          }
        }
      } else if (sch.type === 'string') {
        if (sch.format === 'date-time') {
          // bind to DatetimePicker
          return {
            name: 'datetime-picker',
            props: {
              rules: this.getRules(sch),
              label,
              value: this.internalValue
            }
          }
        } else {
          // all other string fields are simple text input
          let props = {
            label,
            rules: this.getRules(sch)
          }
          if (sch.maxLength != null) {
            props.counter = sch.maxLength
          }
          return { name: 'v-text-field', props }
        }
      } else if (sch.type === 'number') {
        // bind to NumberField
        return {
          name: 'number-field',
          props: {
            min: sch.minimum,
            max: sch.maximum,
            label,
            value: this.internalValue,
            rules: this.getRules(sch)
          }
        }
      } else {
        let msg = `[FormSchema] Unhandled field type : ${sch.type}`
        console.warn(msg, sch)
        return { name: null, props: {}, text: msg }
      }
    }

  }

}
</script>
